import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import NRSelect from '../../../../components/NRControlledSelect/NRSelect';
import NRJiraHighestPriorityIcon from '../../../../NRIcons/NRJiraHighestPriorityIcon';
import NRJiraHighPriorityIcon from '../../../../NRIcons/NRJiraHighPriorityIcon';
import NRJiraLowPriorityIcon from '../../../../NRIcons/NRJiraLowPriorityIcon';
import NRJiraLowestPriorityIcon from '../../../../NRIcons/NRJiraLowestPriorityIcon';
import NRJiraMediumPriorityIcon from '../../../../NRIcons/NRJiraMediumPriorityIcon';

const PRIORITY_ICONS = {
  highest: NRJiraHighestPriorityIcon,
  high: NRJiraHighPriorityIcon,
  medium: NRJiraMediumPriorityIcon,
  low: NRJiraLowPriorityIcon,
  lowest: NRJiraLowestPriorityIcon
};

function normalizePriorityOption(priority) {
  if (priority == null) {
    return null;
  }

  if (typeof priority === 'string') {
    return { id: priority, label: priority };
  }

  const id = priority.id || priority.value;
  const label = priority.label || priority.value || id;

  if (!id) {
    return null;
  }

  return { id, label };
}

function NRJiraPrioritySelect({
  id,
  label,
  value,
  onChange,
  priorityOptions = [],
  disabled = false,
  required = false,
  sxProps
}) {
  const options = useMemo(
    () =>
      priorityOptions
        .map(normalizePriorityOption)
        .filter(Boolean)
        .map(({ id: optionId, label: optionLabel }) => {
          const Icon = PRIORITY_ICONS[optionLabel?.toLowerCase()] ?? NRJiraMediumPriorityIcon;

          return {
            value: optionId,
            overrideLabel: true,
            label: (
              <Box display="flex" alignItems="center" gap={1}>
                <Box display="flex" alignItems="center" flexShrink={0}>
                  <Icon height="20" width="20" />
                </Box>
                <Typography component="span" variant="body2">
                  {optionLabel}
                </Typography>
              </Box>
            ),
            text: optionLabel
          };
        }),
    [priorityOptions]
  );

  return (
    <NRSelect
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      showEmptyValue={false}
      required={required}
      sxProps={sxProps}
    />
  );
}

export default NRJiraPrioritySelect;
